import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <h2 {...{
      "id": "what-is-document-generation"
    }}><strong parentName="h2">{`What is Document Generation?`}</strong></h2>
    <p>{`Document Generation is the method of creating business-critical
documents like invoices, contracts, sales proposals, and work orders
automatically.`}</p>
    <p>{`Documents of such type are made up of the static content that will
remain unchanged and the dynamic content that is customized for the
audience or recipient of the generated document. E.g.: Say when a bank
draws up a contract for a loan. Each contract needs to be customized for
every customer. It will use the same template, but the details for each
customer will be different.`}</p>
    <h2 {...{
      "id": "document-generation-process"
    }}>{`Document Generation Process`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1027px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "46.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/5530d/docgen_process.webp 320w", "/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/0c8fb/docgen_process.webp 640w", "/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/3df8b/docgen_process.webp 1027w"],
            "sizes": "(max-width: 1027px) 100vw, 1027px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/8980b/docgen_process.jpg 320w", "/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/56d4e/docgen_process.jpg 640w", "/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/eda9e/docgen_process.jpg 1027w"],
            "sizes": "(max-width: 1027px) 100vw, 1027px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/be5f084f6a2c69c2ed7b2d343fb71068/eda9e/docgen_process.jpg",
            "alt": "Document Generation Process : Request consisting of a docx file and a json is sent to Adobe Document Generation API by client application. Adobe Document Generation API returns a document with these template tags replaced by the actual data as per the json.",
            "title": "Document Generation Process : Request consisting of a docx file and a json is sent to Adobe Document Generation API by client application. Adobe Document Generation API returns a document with these template tags replaced by the actual data as per the json.",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "components-of-document-generation"
    }}>{`Components of Document Generation`}</h2>
    <p><strong parentName="p">{`Document Template`}</strong></p>
    <p>{`In Document Generation, a document template is a pre-built customized
document with a set of predefined template tags for generating dynamic
content. During the Document Generation process, these template tags
derive values based on the input data and get replaced by the actual
data accordingly.`}</p>
    <p><strong parentName="p">{`Template Tags`}</strong></p>
    <p>{`The rules which indicate the dynamic content in a document are defined
in the form of template tags. These template tags, when placed into a
document (e.g. docx) convert it into a document template.`}</p>
    <p>{`To learn more, please visit `}<a parentName="p" {...{
        "href": "templatetags.md"
      }}>{`Template Tags`}</a></p>
    <p><strong parentName="p">{`Input Data`}</strong></p>
    <p>{`Document Generation is a data-driven process. Based on the input data,
template tags in the document template are replaced and dynamic content
of the final document is generated. Each set of input data may produce a
different document from the document template.`}</p>
    <p><strong parentName="p">{`Document Generation API`}</strong></p>
    <p><a parentName="p" {...{
        "href": "../../apis/#tag/Document-Generation"
      }}>{`Document Generation
API`}</a>{`
accepts a document template (with template tags) along with the input
data to generate the final document. The final document is generated by
replacing all the template tags in the document template with the
dynamic content based on the actual values corresponding to the data
input.`}</p>
    <p>{`To learn more, please visit `}<a parentName="p" {...{
        "href": "quickstarts.md"
      }}>{`QuickStarts`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      